<div class="row container-fluid m-0 p-0" *ngIf="currentProject!=null" >

    <div class="col-md-10 bg-light p-0">

        <!-- Navbar -->
        <nav
            class="navbar navbar-expand-md bg-dark text-light justify-content-between sticky-top border-right border-secondary">
            <ul class="navbar-nav mx-2">
                <!-- Page title -->
                <a class="navbar-brand text-light text-weight-bolder hover-logo" (click)="router.navigate(['/projects'], {queryParams:{userId:userId}})"><i
                        class="fas fa-project-diagram"></i> {{logo}}</a>
            </ul>
            
            <div class="navbar-nav d-flex flex-row">
                <a *ngIf="!modifyProject" class="btn btn-dark text-light" (click)="router.navigate(['/projects'], {queryParams:{userId:userId}})">
                    <i class="fas fa-angle-left"></i> Back
                </a>
                <ul *ngIf="identity.isUserAuthenticated() && identity.isUserAuthorized(userId)" class="navbar-nav mx-2">
                    <!-- Enter edit mode -->
                    <li class="nav-item">
                        <button *ngIf="!modifyProject" class="btn btn-dark text-light" type="button" (click)="modify()">Edit</button>
                        <div *ngIf="modifyProject" class="btn-group">
                            <button class="btn btn-outline-success mr-2" type="button" (click)="child.updateProject()">Save</button>
                            <button class="btn btn-outline-secondary" type="button" (click)="child.cancel()">Cancel</button>
                        </div>
                    </li>
                </ul>
            </div>
            
            
        </nav>
        
        <div *ngIf="startWaitingAnimation" class="progress sticky-top" style="height: 0.2rem">
            <div class="progress-bar" id="progress"></div>
        </div>

        <info-editor [currentProject]=currentProject [(modifyProject)]=modifyProject [userId]=userId [projectId]=projectId></info-editor>

    </div>

    <!-- Other projects -->
    <div class="col-md-2 bg-dark">

        <div class="d-flex justify-content-center text-light bg-dark my-4">
            <h5>See Other Projects</h5>
        </div>
        <!-- Search item -->
        <div class="d-flex justify-content-center">
            <input #myInput class="form-control d-inline-block w-75 h-100" type="text" placeholder="Search" id="filter"
                (input)="filterProjects(myInput.value)">
            <button class="btn btn-dark d-inline-block mw-25">
                <i class="fas fa-search bg-dark text-light"></i>
            </button>
        </div>

        <!--See other projects - For small screens-->
        <button class="btn btn-light toggler d-md-none my-2 bg-dark" type="button" data-toggle="collapse"
            data-target="#collapsible">
            <i class="fas fa-bars bg-dark text-light"></i>
        </button>

        <div class="collapse d-md-none my-2 bg-dark" id="collapsible">
            <ul class="list-group list-group-flush my-2">
                <a (click)="router.navigate(['/infos'], {queryParams:{userId:project.userId, projectId: project.projectId}})"
                    *ngFor="let project of filteredProjects" class="list-group-item btn bg-dark text-light">
                    {{project.title}}
                </a>
            </ul>
            <div class="btn-group d-flex justify-content-center">
                <button class="btn btn-dark text-light" (click)="showMoreLessProjects('m')">
                    <i class="fas fa-angle-down"></i>
                </button>
                <button class="btn btn-dark text-light" (click)="showMoreLessProjects('l')">
                    <i class="fas fa-angle-up"></i>
                </button>
            </div>
        </div>

        <!--See other projects - For big screens-->
        <ul class="list-group list-group-flush my-2 d-none d-md-block">
    
            <div *ngFor="let project of filteredProjects ">
                <a (click)="router.navigate(['/infos'], {queryParams:{userId:project.userId, projectId: project.projectId}})"
                    *ngIf="project.projectId != currentProject.projectId"
                    class="list-group-item btn bg-dark text-light">
                    {{project.title}}
                </a>
                <a (click)="router.navigate(['/infos'], {queryParams:{userId:project.userId, projectId: project.projectId}})"
                    *ngIf="project.projectId == currentProject.projectId"
                    class="list-group-item btn bg-dark text-primary disabled">
                    {{project.title}}
                </a>
            </div>
            <div class="btn-group d-flex justify-content-center">
                <button class="btn btn-dark text-light" (click)="showMoreLessProjects('m')">
                    <i class="fas fa-angle-down"></i>
                </button>
                <button class="btn btn-dark text-light" (click)="showMoreLessProjects('l')">
                    <i class="fas fa-angle-up"></i>
                </button>
            </div>
        </ul>
        
    </div>
</div>

